
import { useState, useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OfferSection } from './components/OfferSection';
import { CheckoutSection } from './components/CheckoutSection';
import { AboutSection } from './components/AboutSection';
import { BenefitsSection } from './components/BenefitsSection';
import { CoursesSection } from './components/CoursesSection';
import { KeyBenefitsSection } from './components/KeyBenefitsSection';
import { CommunitySection } from './components/CommunitySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';

export default function HomePage() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 180000); // 3 minutos = 180000 ms

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      {showContent && (
        <div className="animate-fade-in">
          <OfferSection />
          <CheckoutSection />
          <AboutSection />
          <BenefitsSection />
          <CoursesSection />
          <KeyBenefitsSection />
          <CommunitySection />
          <TestimonialsSection />
          <FAQSection />
          <CTASection />
        </div>
      )}
      <Footer />
    </div>
  );
}
